<template>
  <v-container fluid pa-0>
    <h1 class="headline">Itinerary Contents</h1>
    <contents owner-name="ITINERARY_DEFAULT" owner-id="0" />
  </v-container>
</template>

<script>
import Contents from "../../../gt/shared/contents/Contents";
export default {
  name: "itinerary-contents",
  components: {
    Contents,
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/contents/ItineraryContents.vue